export const SESSION_BUCKET_KEYS = ["ongoing", "upcoming", "past"] as const;

export type SessionBucketKey = (typeof SESSION_BUCKET_KEYS)[number];

export const SESSION_BUCKET = {
  ONGOING: "ongoing",
  UPCOMING: "upcoming",
  PAST: "past",
} as const;

export const DEFAULT_SESSION_BUCKET: SessionBucketKey = SESSION_BUCKET.ONGOING;

export const SESSION_BUCKET_STORAGE_KEY = "meet_session_bucket";

export const isSessionBucketKey = (
  value: string | null
): value is SessionBucketKey =>
  SESSION_BUCKET_KEYS.includes(value as SessionBucketKey);
